module.exports = __webpack_public_path__ + "img/rc.5f2a7d16.jpg";